export default __webpack_public_path__ + "static/footer_logo_ffxiv-7f598f8c-2566e5f707f6325416e797acfb8cdd9a.png";